/* eslint-disable no-void */

import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';

import vopayApi from '../../services/api.config';

type HookProps = {
  api: vp.Api;
};

export type AuthPingResponse = {
  success: boolean;
  errorMessage: string;
};

type ReturnTuple = [AuthPingResponse | undefined, () => void, () => void];

function usePostPartnerAuthPing({ api }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();

  const [response, setResponse] = useState<AuthPingResponse>();
  const [shouldSendRequest, setSendRequest] = useState(false);

  useEffect(() => {
    const sendRequest = async () => {
      const { Success, ErrorMessage } = await api.postPartnerAuthPing(source);

      const res = {
        success: Success,
        errorMessage: ErrorMessage || '',
      };

      setResponse(res);
      setSendRequest(false);

      return () => {};
    };

    if (shouldSendRequest) void sendRequest();

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    () => {
      setSendRequest(true);
    },
    () => {
      setResponse(undefined);
      setSendRequest(false);
    },
  ];
}

export default vopayApi.withApiHook<HookProps, ReturnTuple>(usePostPartnerAuthPing);
